export const OK_BTN_ACTION = 'OK_BTN_ACTION';
export const MID_BTN_ACTION = 'MID_BTN_ACTION';
export const CANCEL_BTN_ACTION = 'CANCEL_BTN_ACTION';